export default __webpack_public_path__ + "static/media/161.42dd84eb.jpg";